
<div class="container">
  <div class="dashboard-header row">
    @if (user) {
      <div class="col-lg-6">
        <div class="page-header-title">
          <ng-container i18n>Hi</ng-container> {{ user.firstName }},
        </div>
        <div class="page-sub-header" i18n>
        This is your personal overview of the day
      </div>
      </div>
    }
    <div class="col-lg-6 new-user-button">
      @if (user) {
        <button (click)="createUser()"><i class="fal fa-user-plus new-user-button-icon"></i><ng-container i18n>Add new user</ng-container></button>
      }
    </div>
  </div>

  @if (user && templates) {
    <div class="row">
      <div class="col-dashboard-left">
        <div class="card-left">
          <div class="active-template-header">
            <h3 i18n>Most active templates</h3>
            <i class="fal fa-chevron-circle-right active-template-header-icon" (click)="toTemplate()"></i>
          </div>
          <div class="select-dropdowns clearfix">
            <select [formControl]="templateMonthSelection">
              @for (option of specificTimeSelections; track option) {
                <option [ngValue]="option">{{ option.title }}</option>
              }
              <option [ngValue]="null" i18n>All</option>
            </select>
          </div>
          @if (templates.length < 1 && loading === false) {
            <h4 class="no-templates" i18n>No templates for selected timeframe</h4>
          }
          @for (template of templates; track template.id) {
            <li class="row template-row">
              <a class="template-img-wrapper" (click)="toContentWithTemplateItemId(template.id)">
                <img class="template-img" src="{{ template.thumbnail }}" alt="">
                @if (template.items.length >= 1) {
                  <div class="image-icon-border">
                    @if (template.items.length > 1) {
                      <i class="fas fa-layer-group image-icon"></i>
                    }
                    @else {
                      <div class="more-items">
                        @switch (template.items[0].type) {
                          @case (ImageTypeEnum.Video) {
                            <i class="fas fa-play-circle image-icon"></i>
                          }
                          @case (ImageTypeEnum.Image) {
                            <i class="far fa-image-polaroid image-icon"></i>
                          }
                          @case (ImageTypeEnum.GIF) {
                            <img src="assets/icons/gif.svg" class="image-icon" alt="">
                          }
                        }
                      </div>
                    }
                  </div>
                }
              </a>
              <div class="template-details">
                <h5 class="template-title" (click)="toContentWithTemplateItemId(template.id)">{{ template.title }}</h5>
                <p class="template-date"> <ng-container i18n>Created on</ng-container> {{ template.created | date }}</p>
                <div class="clearfix">
                  <div class="content-wrapper" (click)="toContentWithTemplateItemId(template.id)">
                    <div class="content-icon-background">
                      <i class="far fa-play-circle content-icon"></i>
                    </div>
                    <div class="content-stats">
                      @if (template.statistics.newContentCount) {
                        <h6>{{ template.statistics.newContentCount | shortNumber }}</h6>
                      }
                      @else {
                        <h6>0</h6>
                      }
                      <p i18n>Unique content</p>
                    </div>
                  </div>
                  <div class="content-wrapper">
                    <div class="content-icon-background">
                      <i class="far fa-eye content-icon"></i>
                    </div>
                    <div class="content-stats">
                      @if (template.statistics.newViewsCount) {
                        <h6>{{ template.statistics.newViewsCount | shortNumber }}</h6>
                      }
                      @else {
                        <h6>0</h6>
                      }
                      <p i18n>Views</p>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          }
        </div>
      </div>
      <div class="col-dashboard-right">
        <div class="card-right">
          <h3 i18n>Usage</h3>
          @if (statistics?.original) {
            <p class="consumption-summary" i18n>Usage is based on the amount of opens.</p>
          }
          @if (statistics?.credits) {
            <p class="consumption-summary" i18n>Usage is based on the amount of credits used.</p>
          }
          <div class="select-dropdowns clearfix">
            <select [formControl]="usageMonthSelection">
              @for (option of monthSelectionOptions; track option) {
                <option [ngValue]="option">{{ option.title }}</option>
              }
            </select>
          </div>
          @if (statistics?.credits) {
            <div class="credit-overview">
              <app-credit-usage
                title="Created content"
                i18n-title
                [images]="statistics?.credits?.imageCredits?.renderCount ?? 0"
                [videos]="statistics?.credits?.videoCredits?.renderCount ?? 0"
                [gifs]="statistics?.credits?.gifCredits?.renderCount ?? 0"
                [total]="usageMonthSelection.value.allowedUsage"
            [totalUsed]="(statistics?.credits?.imageCredits?.usedRenderCredits ?? 0) 
              + (statistics?.credits?.videoCredits?.usedRenderCredits ?? 0) 
              + (statistics?.credits?.gifCredits?.usedRenderCredits ?? 0)"
              ></app-credit-usage>
              <app-credit-usage
                title="Delivered content"
                i18n-title
                [images]="statistics?.credits?.imageCredits?.viewCount ?? 0"
                [videos]="statistics?.credits?.videoCredits?.viewCount ?? 0"
                [gifs]="statistics?.credits?.gifCredits?.viewCount ?? 0"
                [total]="usageMonthSelection.value.allowedUsage * 10"
            [totalUsed]="(statistics?.credits?.imageCredits?.usedViewCredits ?? 0) 
              + (statistics?.credits?.videoCredits?.usedViewCredits ?? 0) 
              + (statistics?.credits?.gifCredits?.usedViewCredits ?? 0)"
              ></app-credit-usage>
            </div>
          }
          @if (statistics?.original) {
            <div class="chart-bar-wrapper">
              <div class="chart-bar-inactive" [ngStyle]="{'width': 105 - chartValue + '%'}"></div>
              <div class="chart-bar-active" [ngStyle]="{'width': chartValue + '%'}">
                <div class="chart-bar-active-inner" [ngStyle]="{'width': (100 * 100 / chartValue) + '%'}"></div>
              </div>
            </div>
            <div class="chart-bar-numbers">
              <h4 class="consumption-total">{{ totalGeneratedCount }}</h4>
              <h6 class="consumption-max">/ {{ usageMonthSelection.value ? usageMonthSelection.value.allowedUsage : 0 }}</h6>
            </div>
            <div class="consumption-row clearfix">
              @if (user) {
                <div class="consumption-images">
                  <div class="consumption-icon-border" [class.grey]="statistics?.original?.imageStats?.newBillableViewsCount === 0">
                    <i class="far fa-image-polaroid consumption-icon" [class.grey]="statistics?.original?.imageStats?.newBillableViewsCount === 0"></i>
                  </div>
                  <h4>{{ statistics?.original?.imageStats?.newBillableViewsCount ?? 0 | shortNumber }}</h4>
                  <p i18n>{statistics?.original?.imageStats?.newBillableViewsCount ?? 0, plural, 1 {Image} other {Images}}</p>
                </div>
                <div class="consumption-videos">
                  <div class="consumption-icon-border" [class.grey]="statistics?.original?.videoStats?.newBillableViewsCount === 0">
                    <i class="fas fa-play-circle consumption-icon" [class.grey]="statistics?.original?.videoStats?.newBillableViewsCount === 0"></i>
                  </div>
                  <h4 >{{ statistics?.original?.videoStats?.newBillableViewsCount ?? 0 | shortNumber}}</h4>
                  <p i18n>{statistics?.original?.videoStats?.newBillableViewsCount ?? 0, plural, 1 {Video} other {Videos}}</p>
                </div>
              }
            </div>
            <div class="consumption-row clearfix">
              @if (user) {
                <div class="consumption-gifs">
                  <div class="consumption-icon-border" [class.grey]="statistics?.original?.gifStats?.newBillableViewsCount === 0">
                    <img [class.grey]="statistics?.original?.gifStats?.newBillableViewsCount === 0" src="assets/icons/gif.svg" class="consumption-icon" alt="">
                  </div>
                  <h4>{{ statistics?.original?.gifStats?.newBillableViewsCount ?? 0| shortNumber }}</h4>
                  <p i18n>{statistics?.original?.gifStats?.newBillableViewsCount ?? 0, plural, 1 {GIF image} other {GIF images}}</p>
                </div>
              }
            </div>
          }
          <div class="credit-addons">
            <app-credit-addons
              [aiCredits]="remainingAiCredits ?? 0"
            ></app-credit-addons>
          </div>
        </div>
      </div>
    </div>
  }
</div>